<template>
  <div class="navbar">
    <el-row style="margin-bottom: 0px">
      <el-col :offset="1" :span="22">
        <a href="/gear19">
          <img src="../../src/assets/ccmb.jpeg" v-if="store.theme.viewMode.active === 'light'"
            style="max-height: 58px; padding: 10px; padding-bottom: 8px; filter: grayscale(100%) opacity(75%);">
          <img src="../../src/assets/ccmb.jpeg" v-else
            style="max-height: 58px; padding: 10px; padding-bottom: 8px; filter: grayscale(100%) opacity(100%) invert(80%);">
          <img src="../../src/assets/logo_light.png" v-if="store.theme.viewMode.active === 'light'"
            style="max-height: 60px; padding: 10px; filter: opacity(60%)">
          <img src="../../src/assets/logo_dark.png" v-else
            style="max-height: 60px; padding: 10px; filter: opacity(90%)">
        </a>
        <span class="menu-span" @click="store.settings.showDraw = true" :style="`float: right;font-weight: bold; margin-top: 20px; cursor: pointer;
            color: ${store.theme.viewMode.iconBackgroundColor[store.theme.viewMode.active]}`">
          <i class="fas icon-fa-bars" style="font-size: 2em;"></i>
        </span>
        <div :style="`padding-left: 15px; color: #424242; font-family: 'Oxygen', Arial, sans-serif;
            color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`">
          <b>Genome Evolution Analysis Resource<br>for COVID-19</b>
          <br>
          <a href="http://e-portal.ccmb.res.in/e-space/rakeshmishra/bioinformatics/index.html" target="_blank"
            :style="`text-decoration: none; color: ${store.theme.viewMode.iconBackgroundColor[store.theme.viewMode.active]}`">
            BIC, CSIR-CCMB
          </a>
        </div>
      </el-col>

      <!-- <el-col :offset="1" :span="22" style="padding-bottom: 20px; padding-top: 20px">
        <a href="/gear19">
          <img src="../../src/assets/logo.png" v-if="store.theme.viewMode.active === 'light'"
            style="max-height: 60px; padding: 10px; filter: opacity(100%)">
          <img src="../../src/assets/logo_dark.png" v-else
            style="max-height: 60px; padding: 10px; filter: opacity(90%)">
        </a>
        <span class="menu-span" @click="store.settings.showDraw = true" :style="`float: right;font-weight: bold; margin-top: 20px; cursor: pointer;
            color: ${store.theme.viewMode.iconBackgroundColor[store.theme.viewMode.active]}`">
          <i class="fas icon-fa-bars" style="font-size: 2em;"></i>
        </span>
        <div :style="`padding-left: 15px; color: #424242; font-family: 'Oxygen', Arial, sans-serif;
            color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`">
          <b>Genome Evolution Analysis Resource<br>for COVID-19</b>, BIC CSIR-CCMB
          <br>
          <div style="margin-top: 10px; padding: 10px; border-radius: 5px; font-family:  'Manrope', Helvetica, Arial, sans-serif; font-weight: bold; background-color: rgba(255,255,255,0.6); width: 340px">
            Conduct your own genomic surveillance of <br> the SARS-CoV-2 virus on our interactive platform.
          </div>
        </div>
      </el-col> -->
    </el-row>

    <el-drawer :visible.sync="store.settings.showDraw" :custom-class="`nav-draw ${store.theme.viewMode.active}`" size="300px;">
      <div slot="title">
        <h4 :style="`color: ${store.theme.viewMode.iconBackgroundColor[store.theme.viewMode.active]}`">
          Genome Evolution Analysis Resource for COVID-19
        </h4>
      </div>
      <el-menu mode="vertical" :router="true" ref='menu' :background-color="store.theme.viewMode.backgroundColor[store.theme.viewMode.active]"
        :text-color="store.theme.viewMode.textColor[store.theme.viewMode.active]">
        
        <el-menu-item index="/" @click="store.settings.showDraw = false">
          <span class="icon-fa-stack fa-2x" style="width: 30px">
            <i class="fas icon-fa-square icon-fa-stack-2x"></i>
            <i class="fas icon-fa-home icon-fa-stack-1x icon-fa-inverse" style="color: #dedede"></i>
          </span>
          <span style="margin-left: 10px"> Home </span>
        </el-menu-item>
        
        <!-- <el-menu-item index="genomes" @click="store.settings.showDraw = false">
          <span class="icon-fa-stack fa-2x" style="width: 30px">
            <i class="fas icon-fa-square icon-fa-stack-2x"></i>
            <i class="fas icon-fa-virus icon-fa-stack-1x icon-fa-inverse" style="color: #dedede"></i>
          </span>
          <span style="margin-left: 10px"> Genomes </span>
        </el-menu-item>
        
        <el-menu-item index="variants" @click="store.settings.showDraw = false">
          <span class="icon-fa-stack fa-2x" style="width: 30px">
            <i class="fas icon-fa-square icon-fa-stack-2x"></i>
            <i class="fas icon-fa-dna icon-fa-stack-1x icon-fa-inverse" style="color: #dedede"></i>
          </span>
          <span style="margin-left: 10px"> Mutations </span>
        </el-menu-item>
        
        <el-menu-item index="covariants" @click="store.settings.showDraw = false">
          <span class="icon-fa-stack fa-2x" style="width: 30px">
            <i class="fas icon-fa-square icon-fa-stack-2x"></i>
            <i class="fas icon-fa-dna icon-fa-stack-1x icon-fa-inverse" style="color: #dedede"></i>
          </span>
          <span style="margin-left: 10px"> Shared Mutations </span>
        </el-menu-item>
        
        <el-menu-item index="state" @click="store.settings.showDraw = false">
          <span class="icon-fa-stack fa-2x" style="width: 30px">
            <i class="fas icon-fa-square icon-fa-stack-2x"></i>
            <i class="fas icon-fa-map-marked-alt icon-fa-stack-1x icon-fa-inverse" style="color: #dedede"></i>
          </span>
          <span style="margin-left: 10px"> State </span>
        </el-menu-item> -->
        
        <!-- <el-menu-item index="reinfection" @click="store.settings.showDraw = false"><span class="icon-fa-stack fa-2x" style="width: 30px">
            <i class="fas icon-fa-square icon-fa-stack-2x"></i>
            <i class="fas icon-fa-head-side-virus icon-fa-stack-1x icon-fa-inverse" style="color: #dedede"></i>
          </span>
          <span style="margin-left: 10px"> Reinfection </span>
        </el-menu-item> -->
        
        <el-menu-item index="about" @click="store.settings.showDraw = false">
          <span class="icon-fa-stack fa-2x" style="width: 30px">
            <i class="fas icon-fa-square icon-fa-stack-2x"></i>
            <i class="fas icon-fa-info icon-fa-stack-1x icon-fa-inverse" style="color: #dedede"></i>
          </span>
          <span style="margin-left: 10px"> About </span>
        </el-menu-item>
        
        <!-- <el-menu-item index="summary" @click="store.settings.showDraw = false">
          <span class="icon-fa-stack fa-2x" style="width: 30px">
            <i class="fas icon-fa-square icon-fa-stack-2x"></i>
            <i class="fas icon-fa-sticky-note icon-fa-stack-1x icon-fa-inverse" style="color: #dedede"></i>
          </span>
          <span style="margin-left: 10px"> Summary </span>
        </el-menu-item> -->
        
        <el-menu-item index="reinfection" @click="store.settings.showDraw = false">
          <el-tooltip content="Nextstrain Analysis" placement="left">
              <a href="https://data.ccmb.res.in/gear19/auspice" target="_blank" style="height: 30px;">
                <img class="nextstrain-logo" src="../assets/nextstrain.png" style="height: 30px;">
                <span :style="`text-decoration: none; margin-left: 10px; color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`"> Nextstrain Analysis </span>
              </a>
          </el-tooltip>
          
        </el-menu-item>
        
        <el-menu-item index="help" @click="store.settings.showDraw = false">
          <span class="icon-fa-stack fa-2x" style="width: 30px">
            <i class="fas icon-fa-square icon-fa-stack-2x"></i>
            <i class="fas icon-fa-question-circle icon-fa-stack-1x icon-fa-inverse" style="color: #4e4e4e"></i>
          </span>
          <span style="margin-left: 10px"> Help </span>
        </el-menu-item>
        
        <el-menu-item index="thanks" @click="store.settings.showDraw = false">
          <span class="icon-fa-stack fa-2x" style="width: 30px">
            <i class="fas icon-fa-square icon-fa-stack-2x"></i>
            <i class="fas icon-fa-thumbs-up icon-fa-stack-1x icon-fa-inverse" style="color: #4e4e4e"></i>
          </span>
          <span style="margin-left: 10px"> Acknowledgements </span>
        </el-menu-item>

         <el-menu-item @click="openModal('SettingsPanel')">
          <span class="icon-fa-stack fa-2x" style="width: 30px">
            <i class="fas icon-fa-square icon-fa-stack-2x"></i>
            <i class="fas icon-fa-cog icon-fa-stack-1x icon-fa-inverse" style="color: #4e4e4e"></i>
          </span>
          <span style="margin-left: 10px"> Settings </span>
        </el-menu-item>

      </el-menu>

      <el-divider></el-divider>
      <el-row :gutter="20" id="draw-view-mode">
        <el-col :offset="2" :span="20">
          <el-button size="medium" class="sidebar-button" @click="viewModeChange" circle :style="`border: none;
              background-color: ${store.theme.viewMode.iconBackgroundColor[store.theme.viewMode.active]}; 
              color: ${store.theme.viewMode.iconColor[store.theme.viewMode.active]}`">
            <i :class="`${store.theme.viewMode.icons[store.theme.viewMode.active]}`" style="font-size: 1.2em"></i>
          </el-button>
          <span style="margin-left: 10px"> View mode </span>
        </el-col>
      </el-row>
    </el-drawer>
  </div>
</template>

<script>
import { store } from '../scripts/store.js'


export default {
  name: 'MainNavBar',
  props: {},
  data() { 
    return { store }
  },
  mounted() {
    // document.getElementById('draw-view-mode').onclick = function() {
    //   console.log('Clicked')
    //    this.store.theme.viewMode.change()
    // }
  },
  methods: {
    openModal(val) {
      store.settings.showDraw = false
      store.modal.openModal(val);
    },
    redirectPage: function (path) {
      this.$router.push(path)
    },
    viewModeChange: function() {
      console.log('View mode changed')
      this.store.theme.viewMode.change()
    }
  }
}
</script>

<style>
.nav-draw.dark {
  background-color: #2e2e2e;
  color: #ffffff;
}

.nav-draw.light {
  background-color: #ffffff;
  color: #2e2e2e;
}

.nextstrain-logo {
  animation-name: spinout;
  animation-duration: 300ms;
  animation-timing-function: ease-in-out;
}

</style>